export const AuthMethod = {
  Native: "native",
  Google: "google",
  Canvas: "canvas",
};

export const RegistrationPageAllowedAuthMethods = [
  AuthMethod.Native,
  AuthMethod.Google,
];
